// extracted by mini-css-extract-plugin
module.exports = {"root":"r5RQrFxO","styledSpan":"_f0Pe4MH"};